export const messages = {
    'executionsFiltersBar.devices.label': 'Modes',
    'executionsFiltersBar.modes.label': 'Type',
    'executionsFiltersBar.statusIds.label': 'Status',
    'executionsFiltersBar.groupIds.label': 'Group',
    'executionsFiltersBar.procedureIds.label': 'Procedure',
    'executionsFiltersBar.lastLoginStart.label': 'Last login',
    'executionsFiltersBar.clearAll': 'Clear all filters',
    'executionsFiltersModal.departments.label': 'Department',
    'executionsFiltersModal.roleIds.label': 'Role',
    'executionsFiltersModal.statusIds.label': 'Status',
    'executionsFiltersModal.lastLogin.label': 'Last login',
    'executionsFiltersModal.groupIds.label': 'Assigned groups',
    'executionsFiltersModal.procedureIds.label': 'Assigned procedures',
    'executionsFiltersModal.lastLogin.lastWeek': 'Within last week',
    'executionsFiltersModal.lastLogin.lastMonth': 'Within last month',
    'executionsFiltersModal.lastLogin.lastThreeMonth': 'Within last three months',
    'executionsFiltersModal.lastLogin.lastYear': 'Within last year',
    'executionsFiltersModal.lastLogin.weekAgo': 'More than a week ago',
    'executionsFiltersModal.lastLogin.monthAgo': 'More than a month ago',
    'executionsFiltersModal.lastLogin.threeMonthsAgo': 'More than three months ago',
    'executionsFiltersModal.lastLogin.yearAgo': 'More than a year ago',
    'executionsFiltersModal.title': 'Filter user list',
    'executionsFiltersModal.button.cancel': 'Cancel',
    'executionsFiltersModal.button.submit': 'Apply filter',
    'neoAnalyticsPage.noInfo': 'No information',
    'neoAnalyticsPage.table.procedures.header': 'Procedures',
    'neoAnalyticsPage.table.date.header': 'Date',
    'neoAnalyticsPage.table.modes.header': 'Modes',
    'neoAnalyticsPage.table.types.header': 'Types',
    'neoAnalyticsPage.table.attempts.header': 'N. Attempt',
    'neoAnalyticsPage.filter.title': 'Filter',
    'neoAnalyticsPage.title': 'Users',
    'neoAnalyticsPage.noExecutionsInGroup': 'There are no executions in this group',
    'neoAnalyticsSidebar.button.allExecutions': 'All executions',
    'neoAnalytics.toggle.sessions': 'Sessions',
    'neoAnalytics.toggle.sessionInfo': 'Session Info',
    'neoAnalytics.toggle.insights': 'Insights',
    'neoAnalytics.toggle.back': 'Back',
    'neoAnalytics.graph.toggle': 'Performance graph',
    'executionSummaryGraph.view.graph': 'Chart view',
    'executionSummaryGraph.view.timeline': 'Timeline view',
    'executionSummaryGraph.zoom.in': 'Zoom in',
    'executionSummaryGraph.zoom.out': 'Zoom out',
    'executionSummaryGraph.zoom.reset': 'Reset zoom',
    'executionSummaryGraph.stepGroup.title': 'steps in this range',
};
